import React from "react";
import { Table as Table2 } from '@devexpress/dx-react-grid-material-ui';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { isAllowed, authRoles } from "../../../../auth/auth";

const SelectFilterCell = ({ filter, onFilter, user }) => {
    return (
        <Table2.Cell>
            <Select
                value={filter ? filter.value : ''}
                onChange={e => onFilter(e.target.value ? { value: e.target.value } : null)}
                inputProps={{
                    name: 'filterByRole',
                    id: 'filterByRole',
                }}
                style={filter ? { minWidth: '100px', fontWeight: '500' } : { minWidth: '100px', fontWeight: '400', color: '#A2A2A2' }}
                displayEmpty
            >
                <MenuItem value="">
                    None
                </MenuItem>
                {isAllowed(user, authRoles.superAdmin) ? <MenuItem value={"ROLE_SUPER_ADMIN"}>Super Admin</MenuItem> : null}
                <MenuItem value={'ROLE_ADMIN'}>Admin</MenuItem>
                <MenuItem value={'ROLE_EDITOR'}>Editor</MenuItem>
                <MenuItem value={'ROLE_VIEWER'}>Viewer</MenuItem>
            </Select>
        </Table2.Cell>
    )
};

export default SelectFilterCell;


// WEBPACK FOOTER //
// ./src/main/content/user-management/filter-cell/FilterCell.js